<template>
  <div>
    <Title :pages="[{ icon: 'wallet', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <Modal
        v-if="create_access"
        :button_name="$t('Crear') + ' ' + modal_title"
        :modal_title="modal_title"
        :formBtn="formBtn"
        :dialog="dialog"
        :parent="parent"
        :service="service"
        @updateDialog="updateDialog"
        @loadList="filter"
        :item="mainItem"
        @updateItem="
          (newItem) => {
            mainItem = newItem;
          }
        "
      />

      <!-- Panel resumen de fondos -->
      <v-card v-if="list_access" class="mb-4 rounded-lg" elevation="3" dark color="#2C3E50">
        <v-card-text class="pa-5">
          <div class="d-flex align-center justify-space-between flex-wrap">
            <div class="d-flex align-center">
              <div class="mr-4 pa-3 rounded-lg" style="background: rgba(255, 255, 255, 0.18)">
                <v-icon size="32">account_balance_wallet</v-icon>
              </div>
              <div>
                <div class="text-h6 font-weight-bold">Fondos Disponibles</div>
                <div class="caption" style="opacity: 0.75">Consolidado: Bancos + Efectivo</div>
              </div>
            </div>
            <div class="text-right mt-2 mt-sm-0">
              <div class="text-h4 font-weight-bold">{{ formatUtils.formatPrice(totalFondos) }}</div>
              <v-chip small color="white" text-color="#2C3E50" class="mt-1 font-weight-medium"> Liquidez Inmediata </v-chip>
            </div>
          </div>
        </v-card-text>
      </v-card>

      <!-- Cards por tipo de cuenta -->
      <v-row v-if="list_access" class="mb-4">
        <v-col v-for="card in summaryCards" :key="card.key" cols="12" sm="6" md="3">
          <v-card class="pa-4 rounded-lg" elevation="1">
            <div class="d-flex justify-space-between align-center mb-3">
              <div class="rounded-lg pa-2" :style="{ background: card.bgColor }">
                <v-icon :color="card.iconColor" size="22">{{ card.icon }}</v-icon>
              </div>
              <v-chip small label color="#F5F5F5" class="font-weight-medium"> {{ card.count }} {{ card.countLabel }} </v-chip>
            </div>
            <div class="caption grey--text text--darken-1 mb-1 text-uppercase font-weight-medium">
              {{ card.label }}
            </div>
            <div class="text-h6 font-weight-bold" :class="card.total < 0 ? 'red--text' : ''">
              {{ formatUtils.formatPrice(card.total) }}
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-card>
        <div class="row mb-4">
          <div class="col-md-12" v-if="list_access">
            <div class="col-md-12" style="background:white; elevation-0">
              <div class="row pt-5">
                <div class="col-md-3 pt-0">
                  <v-combobox v-model="filterEmitter" autocomplete="off" item-text="name" item-value="id" :items="emitters" label="Empresa" class="pt-0 mt-0" clearable></v-combobox>
                </div>
                <div class="col-md-3 pt-0">
                  <v-combobox v-model="filterAccountType" autocomplete="off" item-text="name" item-value="id" :items="accountTypes" label="Tipo de cuenta" class="pt-0 mt-0" clearable></v-combobox>
                </div>

                <div class="col-md-2 pt-0">
                  <v-select
                    v-model="filterRepresentaFondos"
                    :items="[{ text: 'Todas', value: null }, { text: 'Representa fondos', value: true }, { text: 'No representa fondos', value: false }]"
                    item-text="text"
                    item-value="value"
                    label="Fondos"
                    class="pt-0 mt-0"
                    clearable
                  ></v-select>
                </div>

                <div class="col-md-2 pt-0 d-flex align-center">
                  <v-checkbox v-model="filterEnabled" label="Habilitada" hide-details class="mt-0 pt-0"></v-checkbox>
                </div>

                <div class="col-md-2 pt-0" style="display: flex; justify-content: end; align-items: center">
                  <v-btn color="info" @click="filter">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <v-card v-if="list_access">
        <v-card-title>
          <span class="text-uppercase">{{ page_title }}</span>
          <v-btn icon small @click="dialog_help = true" class="ml-2" title="Ayuda">
            <v-icon color="grey darken-1">help_outline</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="list"
          :search="search"
          :loading="loading"
          loading-text="Cargando..."
          :options="{
            descending: true,
            itemsPerPage: 15,
          }"
          @pagination="updatePagination"
          :footer-props="{
            itemsPerPageOptions: [5, 10, 15, 50, -1],
          }"
        >
          <template v-slot:item="props">
            <tr style="height: 64px">
              <!-- Cuenta: nombre + código -->
              <td style="min-width: 180px">
                <div class="font-weight-medium">{{ props.item.name }}</div>
                <div class="caption grey--text">{{ props.item.code }}</div>
              </td>

              <!-- Tipo: chip + subtipo + cuenta padre -->
              <td style="min-width: 160px">
                <v-chip small :color="getTypeChipColor(props.item.account_type)" :text-color="getTypeChipTextColor(props.item.account_type)" class="mb-1">
                  <v-icon x-small left :color="getTypeChipTextColor(props.item.account_type)">{{ getTypeChipIcon(props.item.account_type) }}</v-icon>
                  {{ props.item.account_type ? props.item.account_type.name : "-" }}
                </v-chip>
                <div v-if="props.item.sub_account_type" class="caption grey--text">
                  {{ props.item.sub_account_type.name }}
                </div>
                <div v-if="props.item.parent_money_account" class="caption grey--text">
                  <v-icon style="font-size: 10px" class="mr-1">subdirectory_arrow_right</v-icon>{{ props.item.parent_money_account.name }}
                </div>
              </td>

              <!-- Empresa: emisor + banco -->
              <td style="min-width: 160px">
                <div v-if="props.item.emitter" class="font-weight-medium">{{ props.item.emitter.name }}</div>
                <div v-if="props.item.bank" class="caption grey--text">{{ props.item.bank.name }}</div>
                <span v-if="!props.item.bank && !props.item.emitter" class="grey--text">-</span>
              </td>

              <!-- Balance -->
              <td class="text-right font-weight-bold" :class="props.item.ctacte < 0 ? 'red--text' : 'grey--text text--darken-3'">
                {{ formatUtils.formatPrice(props.item.ctacte) }}
              </td>

              <!-- Habilitado -->
              <td class="text-center">
                <v-icon v-if="props.item.enabled" small color="green darken-1">check_circle</v-icon>
                <v-icon v-else small color="grey lighten-1">cancel</v-icon>
              </td>

              <!-- Acción -->
              <td class="text-right" style="min-width: 180px; white-space: nowrap">
                <v-btn x-small color="teal darken-1" dark depressed class="libro-mayor-btn mr-2" @click="goToBalances(props.item)">
                  <v-icon x-small>menu_book</v-icon>
                  <span class="libro-mayor-label">Libro Mayor</span>
                </v-btn>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="blue darken-1" class="mr-2" @click="viewItem(props.item)">remove_red_eye</v-icon>
                  </template>
                  <span>Ver</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="update_access" v-on="on" small color="blue darken-1" class="mr-2" @click="editItem(props.item)">edit</v-icon>
                  </template>
                  <span>{{ props.item.internal ? "Editar cuenta contable" : "Editar" }}</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="delete_access && !props.item.internal" v-on="on" small color="red darken-1" @click="deleteItem(props.item)">delete</v-icon>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              {{ "Busqueda sin resultados - " + search }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card>

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteItemConfirm" />
      <ModalHelp :show="dialog_help" @close="dialog_help = false" />
    </v-container>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";
import { emmiterService } from "@/libs/ws/emmiterService";
import GenericMixin from "@/mixins/GenericMixin.vue";
import Title from "@/components/Title.vue";
import DialogDelete from "@/components/DialogDelete.vue";
import Modal from "./Modal.vue";
import ModalHelp from "./ModalHelp.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import { formatUtils } from "@/libs/utils/formatUtils";

export default {
  components: { Title, Modal, DialogDelete, ModalHelp },
  mixins: [GenericMixin, RolMixin],
  computed: {
    categorizedList() {
      const bancos = [];
      const efectivo = [];
      const tarjetas = [];
      const otros = [];

      this.list.forEach((item) => {
        const typeName = item.account_type ? item.account_type.name.toLowerCase() : "";
        if (typeName.includes("banco")) {
          bancos.push(item);
        } else if (typeName.includes("efectivo") || typeName.includes("caja")) {
          efectivo.push(item);
        } else if (typeName.includes("tarjeta")) {
          tarjetas.push(item);
        } else {
          otros.push(item);
        }
      });

      return { bancos, efectivo, tarjetas, otros };
    },

    summaryCards() {
      const { bancos, efectivo, tarjetas, otros } = this.categorizedList;
      const sum = (items) => items.reduce((s, i) => s + (parseFloat(i.ctacte) || 0), 0);

      return [
        {
          key: "banco",
          label: "Bancos",
          countLabel: "Cuentas",
          icon: "account_balance",
          iconColor: "#1565C0",
          bgColor: "#E3F2FD",
          count: bancos.length,
          total: sum(bancos),
        },
        {
          key: "efectivo",
          label: "Efectivo",
          countLabel: "Cajas",
          icon: "payments",
          iconColor: "#2E7D32",
          bgColor: "#E8F5E9",
          count: efectivo.length,
          total: sum(efectivo),
        },
        {
          key: "tarjeta",
          label: "Tarjetas",
          countLabel: "Tarjetas",
          icon: "credit_card",
          iconColor: "#7B1FA2",
          bgColor: "#F3E5F5",
          count: tarjetas.length,
          total: sum(tarjetas),
        },
        {
          key: "otros",
          label: "Otras Cuentas",
          countLabel: "Cuentas",
          icon: "account_balance_wallet",
          iconColor: "#757575",
          bgColor: "#F5F5F5",
          count: otros.length,
          total: sum(otros),
        },
      ];
    },

    totalFondos() {
      const { bancos, efectivo } = this.categorizedList;
      const sum = (items) => items.reduce((s, i) => s + (parseFloat(i.ctacte) || 0), 0);
      return sum(bancos) + sum(efectivo);
    },
  },

  data() {
    return {
      formatUtils: formatUtils,
      parent: this,
      dialog_help: false,
      service: generalService,
      page_title: "Cuentas Tesoreria",
      modal_title: "Cuenta",
      mainItem: {
        id: "",
        code: "",
        name: "",
        account_type: null,
        sub_account_type: null,
        representa_fondos: true,
        alias: null,
        cbu: null,
        emitter: null,
        ctacte: null,
        bank: null,
        enabled: true,
      },
      defaultItem: null,
      headers: [
        { text: "Cuenta", align: "left", sortable: true, value: "name" },
        { text: "Tipo", align: "left", sortable: true, value: "account_type.name" },
        { text: "Empresa", align: "left", sortable: true, value: "emitter.name" },
        { text: "Balance", align: "right", sortable: true, value: "ctacte" },
        { text: "Habilitado", align: "center", sortable: true, value: "enabled" },
        { text: "Acción", align: "right", value: "" },
      ],
      list: [],
      dialog_delete: false,
      filterAccountType: null,
      filterEmitter: null,
      filterEnabled: true,
      filterRepresentaFondos: null,
      accountTypes: [],
      emitters: [],
    };
  },
  mounted() {
    this.defaultItem = JSON.parse(JSON.stringify(this.mainItem));
    this.loadComboData();
    this.service.setSection(Constant.SECTION_MONEY_ACCOUNTS);
    this.loadList(this.service, this.getFilterParams());
  },
  methods: {
    getTypeChipColor(accountType) {
      if (!accountType) return "#F5F5F5";
      const name = accountType.name.toLowerCase();
      if (name.includes("banco")) return "#E3F2FD";
      if (name.includes("efectivo") || name.includes("caja")) return "#E8F5E9";
      if (name.includes("tarjeta")) return "#F3E5F5";
      return "#F5F5F5";
    },

    getTypeChipTextColor(accountType) {
      if (!accountType) return "#757575";
      const name = accountType.name.toLowerCase();
      if (name.includes("banco")) return "#1565C0";
      if (name.includes("efectivo") || name.includes("caja")) return "#2E7D32";
      if (name.includes("tarjeta")) return "#7B1FA2";
      return "#757575";
    },

    getTypeChipIcon(accountType) {
      if (!accountType) return "account_balance_wallet";
      const name = accountType.name.toLowerCase();
      if (name.includes("banco")) return "account_balance";
      if (name.includes("efectivo") || name.includes("caja")) return "payments";
      if (name.includes("tarjeta")) return "credit_card";
      return "account_balance_wallet";
    },

    getFilterParams() {
      const param = {};
      if (this.filterAccountType != null) {
        param.account_type = typeof this.filterAccountType === "object" ? this.filterAccountType.id : this.filterAccountType;
      }
      if (this.filterEmitter != null) {
        param.emitter_id = typeof this.filterEmitter === "object" ? this.filterEmitter.id : null;
      }
      param.enabled = this.filterEnabled;
      param.representa_fondos = this.filterRepresentaFondos !== null ? this.filterRepresentaFondos : "all";
      return param;
    },
    loadComboData() {
      emmiterService
        .filter()
        .then((response) => {
          this.emitters = response.result;
        })
        .catch((e) => {
          console.log("emmiterService.filter error", e);
        });

      generalService.setSection(Constant.SECTION_MONEY_ACCOUNTS);
      generalService
        .getCustom("account_types")
        .then((response) => {
          this.accountTypes = response.result;
        })
        .catch((e) => {
          console.log("account_types error", e);
        });
    },
    filter() {
      this.service.setSection(Constant.SECTION_MONEY_ACCOUNTS);
      this.loadList(this.service, this.getFilterParams());
    },
    goToBalances(item) {
      this.$router.push({
        path: "/" + Constant.SECTION_MONEY_ACCOUNTS + "/balance/" + item.id,
        query: { name: item.name },
      });
    },
    deleteItemConfirm() {
      this.service.setSection(Constant.SECTION_MONEY_ACCOUNTS);
      this.delete(this.service);
      this.dialog_delete = false;
      this.service.setSection(Constant.SECTION_MONEY_ACCOUNTS);
      this.loadList(this.service, this.getFilterParams());
    },
  },
};

// TODO agregar un boton de limpiar busqueda.
</script>

<style scoped>
.libro-mayor-btn .libro-mayor-label {
  max-width: 0;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
  transition: max-width 0.25s ease, margin-left 0.25s ease;
  margin-left: 0;
}

.libro-mayor-btn:hover .libro-mayor-label {
  max-width: 80px;
  margin-left: 4px;
}
</style>
